var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartTranont(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "51px",
    viewBox: "0 0 50 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / cart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v40-117-&-v40-155",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v40-53-1",
    transform: "translate(-1227, -444)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1184, 347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(0, 69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-cart",
    transform: "translate(43, 28.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0, 3.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3211036,40.1074878 C25.3211036,42.9824202 23.005178,45.3125 20.1489673,45.3125 C17.2927567,45.3125 14.976831,42.9824202 14.976831,40.1074878 C14.976831,38.9149017 15.3753498,37.8160725 16.0456394,36.9384326 C13.9996911,35.6201174 12.5535186,33.4213008 12.2557269,30.8340396 L12.0569233,29.1068031 C12.0328734,28.99723 12.0194607,28.8836335 12.0178316,28.7671677 L9.60579849,7.81104331 C9.31353989,5.2718545 7.177777,3.35623856 4.63903743,3.35623856 L1.66666762,3.35623856 C0.746192511,3.35623856 0,2.60491896 0,1.67811928 C0,0.751319593 0.746192511,0 1.66666762,0 L4.63903743,0 C8.28780258,0 11.4371239,2.37418857 12.5474032,5.741664 L46.8405101,7.54577076 C48.6789526,7.64248835 50.0914346,9.22148571 49.995377,11.0725601 C49.9816127,11.3378062 49.9366254,11.6004694 49.8613595,11.8550366 L46.1450237,24.4245761 C45.0931664,27.9822098 41.8446797,30.4211744 38.1580812,30.4211744 L15.5638512,30.4211744 L15.5669009,30.4476709 C15.8591595,32.9868597 17.9949224,34.9024756 20.533662,34.9024756 L44.687248,34.9024756 C45.6077232,34.9024756 46.3539157,35.6537952 46.3539157,36.5805949 C46.3539157,37.5073946 45.6077232,38.2587142 44.687248,38.2587142 L42.1232004,38.2587142 C42.3401579,38.8331984 42.4589505,39.4563693 42.4589505,40.1074878 C42.4589505,42.9824202 40.1430248,45.3125 37.2868142,45.3125 C34.4306035,45.3125 32.1146779,42.9824202 32.1146779,40.1074878 C32.1146779,39.4563693 32.2334705,38.8331984 32.4504279,38.2587142 L24.9853536,38.2587142 C25.202311,38.8331984 25.3211036,39.4563693 25.3211036,40.1074878 Z M38.1580812,27.0649359 C40.3700403,27.0649359 42.3191323,25.6015571 42.9502467,23.4669769 L46.6665825,10.8974374 L13.1135146,9.13226294 L15.1775508,27.0649359 L38.1580812,27.0649359 Z M37.2868142,41.9562614 C38.3026373,41.9562614 39.1256152,41.1282538 39.1256152,40.1074878 C39.1256152,39.0867219 38.3026373,38.2587142 37.2868142,38.2587142 C36.270991,38.2587142 35.4480131,39.0867219 35.4480131,40.1074878 C35.4480131,41.1282538 36.270991,41.9562614 37.2868142,41.9562614 Z M20.1489673,41.9562614 C21.1647905,41.9562614 21.9877684,41.1282538 21.9877684,40.1074878 C21.9877684,39.0867219 21.1647905,38.2587142 20.1489673,38.2587142 C19.1331442,38.2587142 18.3101663,39.0867219 18.3101663,40.1074878 C18.3101663,41.1282538 19.1331442,41.9562614 20.1489673,41.9562614 Z",
    id: "Icon-Color",
    fill: "#ffffff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartTranont);
export default __webpack_public_path__ + "static/media/cart_tranont.77a3d775fbbbf702e06460a04991031f.svg";
export { ForwardRef as ReactComponent };